// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --configuration=dev` replaces `environment.ts` with `environment.dev.ts`.
// The list of file replacements can be found in `angular.json`.

// Sandbox: the same build serves admin.omni.dev... AND sandbox.omni.dev...
// When the page is opened on a sandbox.* hostname, the app talks to the
// sandbox API instead of the main one. One build, so the sandbox UI can
// never run a different version than the main UI.
const isSandbox = typeof window !== 'undefined' && window.location.hostname.startsWith('sandbox.');

export const environment = {
  production: true,
  isSandbox,
  // Where the "Go to Sandbox" link (live) and "Back to live" link (sandbox)
  // point. Empty = link hidden (local builds have no sandbox).
  sandboxUrl: 'https://sandbox.omni.dev.barkani.com',
  liveUrl: 'https://admin.omni.dev.barkani.com',
  COMPANY_NAME: 'Barkani',
  COMPANY_SITE: 'Barkani.com',
  socketUrl: isSandbox ? 'https://ws.sandbox.omni.dev.barkani.com' : 'https://ws.omni.dev.barkani.com',
  apiBaseUrl: isSandbox ? 'https://api.sandbox.omni.dev.barkani.com/api' : 'https://api.omni.dev.barkani.com/api',
  // Medexus grants portal (applicant admin pages linked from Grants → People).
  medexusUrl: 'https://medexus.omni.dev.barkani.com',
  GOOGLE_OAUTH2_CLIENT_ID: '115315553953-20bsar37abe7tn3gr7oa0n07g1e81dq2.apps.googleusercontent.com',
  GOOGLE_MAP_API_KEY: 'AIzaSyAfnXYbYsdFlEw46wd1R21aKvzfwXk_ROg',
  FACEBOOK_APP_ID: '1017310152622713',
  APPLE_CLIENT_ID: 'com.barkani.omni',
  APPLE_REDIRECT_URI: 'https://admin.omni.dev.barkani.com',
  AUTH0: {
    clientID: '4q19pzVJIbR9PQKVkzIyZWzR0RTPNhqQ',
    domain: 'barkani.us.auth0.com',
    // audience: 'localhost',
    redirectUri: 'http://localhost:4200/login',
  },
};

/*
 * In development mode, for easier debugging, you can ignore zone related error
 * stack frames such as `zone.run`/`zoneDelegate.invokeTask` by importing the
 * below file. Don't forget to comment it out in production mode
 * because it will have a performance impact when errors are thrown
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
